import openKustomer from '@src/functions/kustomer';
import classes from '@src/styles/BottomCTA.module.css'
import Link from 'next/link'
import useAppLink from '@src/hooks/useAppLink';

type BottomCTAProps = { isProviderPortal?: boolean; isB2b?: boolean }

function BottomCTA({ isProviderPortal = false, isB2b = false }: BottomCTAProps) {
  // gclid/keyword/location/utm_* are stamped on at click time rather than read
  // off router.query, so the CTA stays attributed after the visitor has
  // navigated away from the URL the ad landed on. See src/functions/attribution.ts.
  const appLink = useAppLink();
  return (
    <section className={classes.container}>
      <div className={classes.mainContent}>
        <div className={classes.content}>
          <h4 className={classes.topHeading}>Let&apos;s Get Started</h4>
          <h2 className={classes.heading}>
            {isB2b ? (
              <>
                Are You Ready
                <br />
                to Solve Your Waste
                <br />
                Management
                <br />
                Worries?
              </>
            ) : (
              <>
                Radically
                <br />
                Simplified Waste
                <br />
                Management
              </>
            )}
          </h2>
        </div>
        <div className={classes.content}>
          {isProviderPortal ? (
            <Link className={classes.primaryButton} href={appLink(`${process.env.NEXT_PUBLIC_REDIRECT_URL}?login=1`)}>
              Sign Up Now
            </Link>
          ) : (
            <Link href={appLink(`${process.env.NEXT_PUBLIC_REDIRECT_URL}booking?step=initial&redirect=1`)} className={classes.primaryButton}>
              Book Now
            </Link>
          )}
          <button className={classes.secondaryButtonDark} onClick={openKustomer}>
            Chat With Us
          </button>
        </div>
      </div>
    </section>
  )
}

export default BottomCTA
